import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../ApplicationState';

import { LICENSE_EXPIRY_UPPER_LIMIT, getReadableUnixTimeDateOnly } from '../GlobalFunctions';

import styles from './AccountSettingsForms.module.scss';

const calculateExpired = (cardExpiryYear: number, cardExpiryMonth: number) => {
  const date = new Date();
  const curYear = date.getFullYear();
  const curMonth = date.getMonth() + 1;
  return curYear > cardExpiryYear || (curYear === cardExpiryYear && curMonth <= cardExpiryMonth) ? true : false;
};

const mapStateToProps = (state: RootState) => ({
  userProfile: state.user.userProfile,
});

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const Subscription = (props: PropsFromRedux) => {
  const userInfo = props.userProfile;

  const licenseLevel = userInfo?.licenseLevel;
  const licenseExpires = userInfo?.licenseExpires || 0;
  const dec9999 = Number(2.534e14);
  const maxlicenseExpiry = Math.min(dec9999, licenseExpires);
  const expiryDate = getReadableUnixTimeDateOnly(maxlicenseExpiry);
  const cardDigits = userInfo?.stripeCustomer?.last4 ?? '';
  const cardExpiryMonth = userInfo?.stripeCustomer?.exp_month ?? 0;
  const cardExpiryYear = userInfo?.stripeCustomer?.exp_year ?? 0;
  const cardBrand = userInfo?.stripeCustomer?.brand ?? '';
  const brandCapitalized = cardBrand.charAt(0).toUpperCase() + cardBrand.slice(1);

  const isCardExpired = calculateExpired(cardExpiryYear, cardExpiryMonth);

  const cardExpiryMessage = isCardExpired ? 'Your card has expired' : `Expires: ${cardExpiryMonth}/${cardExpiryYear}`;

  const licenseExpiryMessage =
    licenseExpires !== LICENSE_EXPIRY_UPPER_LIMIT && licenseExpires > Date.now()
      ? 'License Expires'
      : 'License Expired';

  const isHideExpiry = licenseLevel === 'BASIC' ? true : false;

  const licenseLevelforDisplay = licenseLevel?.includes('CLASSROOM')
    ? licenseLevel.replace('CLASSROOM', 'PEEKAPAK PRO')
    : licenseLevel;

  return (
    <section className={styles.container}>
      <div className={styles.formSimulator}>
        <div className={styles.halfRow}>
          <div>
            <p className={styles.label}>Current License</p>
            <p className={styles.text}>{licenseLevelforDisplay}</p>
          </div>
        </div>
        {!isHideExpiry && (
          <div className={styles.halfRow}>
            <div>
              <p className={styles.label}>{licenseExpiryMessage}</p>
              <p className={styles.text}>{expiryDate}</p>
            </div>
          </div>
        )}

        <div className={styles.fullRow}>
          <p className={styles.label}>Payment method</p>
          {cardDigits ? (
            <p className={styles.smallText}>
              {brandCapitalized} ending in {cardDigits};
              <br />
              {cardExpiryMessage}
            </p>
          ) : (
            <p className={styles.smallText}>No credit card on file</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default connector(Subscription);
